import ProductSamplesModal from 'components/GlobalModals/ProductSamplesModal/ProductSamplesModal';
import { withProductSamplesModalProps } from 'viewModel/samples/productSamplesModal/withProductSamplesModalProps';

export default withProductSamplesModalProps(ProductSamplesModal);
